import { render, staticRenderFns } from "./create-or-edit-blogrolls.vue?vue&type=template&id=0308217c&scoped=true&"
import script from "./create-or-edit-blogrolls.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-blogrolls.vue?vue&type=script&lang=js&"
import style0 from "./create-or-edit-blogrolls.vue?vue&type=style&index=0&id=0308217c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308217c",
  null
  
)

export default component.exports